import React from 'react'

const DateExtractorViewResult = ({result}) => {
  const getDates = (result) => {
    if (result?.dates) return result.dates;
    if (result?.response?.dates) return result.response.dates;
    return { found: [], standardized: [] };
  };

  const dates = getDates(result);
  
  return (
    <div className="mt-4 overflow-x-auto">
      <table className="table table-zebra w-full">
        <thead>
          <tr className="bg-base-200">
            <th className="font-bold">Found Date</th>
            <th className="font-bold">Standardized Format</th>
          </tr>
        </thead>
        <tbody>
          {dates.found.map((foundDate, index) => (
            <tr key={index}>
              <td className="font-medium">{foundDate || '-'}</td>
              <td>{dates.standardized[index] || '-'}</td>
            </tr>
          ))}
          {dates.found.length === 0 && (
            <tr>
              <td colSpan="2" className="text-center text-base-content/70">
                No dates found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  )
}

export default DateExtractorViewResult
